// Multi-line text attribute. Objects and arrays are pretty-printed for editing.

import React from 'react';
import TextArea from '@decisiv/ui-components/lib/components/TextArea';

import { formatDisplayValue } from '../../core/values';
import { fieldPropTypes } from './fieldPropTypes';

const TextAreaInput = ({
  descriptor,
  label,
  value,
  warningMessage = '',
  readOnly = true,
  onChange,
  onBlur,
}) => (
  <TextArea
    name={descriptor.name}
    label={label}
    required={descriptor.required}
    helpMessage={descriptor.description}
    warningMessage={warningMessage}
    disabled={readOnly}
    value={formatDisplayValue(value) ?? ''}
    onChange={(e) => onChange(descriptor.name, e.target.value)}
    onBlur={() => onBlur?.(descriptor.name)}
  />
);

TextAreaInput.propTypes = fieldPropTypes;

export default TextAreaInput;
